import React from "react";
import GreyCard from "./GreyCard";
//import { SpecificBooking } from "../../../../types/responseTypes";

interface PostInstalationStatisticsCardProps {
  //specificBooking: SpecificBooking;
  status: string;
  producing: number | string;
  consuming: number | string;
  description: string;
  statusIndicatorColor: string;
}

const PostInstalationStatisticsCard: React.FC<PostInstalationStatisticsCardProps> = ({
  //specificBooking,
  status,
  producing,
  consuming,
  description,
  statusIndicatorColor,
}) => {

  /*
  const colors = {
    "Operativo": "#80BF80",
    "Parcial": "#EBCF4D",
    "En proceso de instalación": "#EBCF4D",
    "No operativo": "#FF0000",
  }
  const statistics = {
    status: "Parcial",
    statusIndicatorColor: colors["Parcial"],
    producing: specificBooking.totalAnnualGeneration,
    consuming: specificBooking.autoConsumption,
    description: "Tu sistema está instalado y funcionando, pero sin poder inyectar (y vender) a la red. Esto quedará operativo cuando todo el tramite con la SEC quede listo y aprueben la instalación
  }
  */

  const unit = "kWh";

  return (
    <GreyCard>
      <div className="flex flex-col justify-start w-full px-4 py-2 gap-2">
        {/* Primera fila: Estado y valores */}
        <div className="flex justify-between items-center w-full px-4">
          {/* Estado */}
          <div>
            <p className="text-[14px] text-[#6D707E] font-montserrat">Estado</p>
            <div className="flex items-center gap-2">
              <p className="font-semibold text-[16px] text-[#1A1A1A] font-montserrat">
                {status}
              </p>
              <div
                className="w-2.5 h-2.5 rounded-full"
                style={{ backgroundColor: statusIndicatorColor }}
              ></div>
            </div>
          </div>

          {/* Produciendo */}
          <div className="items-center">
            <p className="text-[14px] text-[#6D707E] font-montserrat">
              Produciendo
            </p>
            <p className="text-center font-bold text-[16px] text-[#1A1A1A] font-montserrat">
              {producing ? producing : '-'} {unit}
            </p>
          </div>

          {/* Consumiendo */}
          <div>
            <p className="text-[14px] text-[#6D707E] font-montserrat">
              Consumiendo
            </p>
            <p className="text-center font-bold text-[16px] text-[#1A1A1A] font-montserrat">
              {consuming ? consuming : '-'} {unit}
            </p>
          </div>
        </div>

        {/* Descripción */}
        <div className="text-[#6D707E] text-[14px] leading-[17px] mt-2 font-montserrat">
          {description}
        </div>
      </div>
    </GreyCard>
  );
};

export default PostInstalationStatisticsCard;
